import { render, staticRenderFns } from "./QueueCompareModal.vue?vue&type=template&id=947b7f26&scoped=true&"
import script from "./QueueCompareModal.vue?vue&type=script&lang=js&"
export * from "./QueueCompareModal.vue?vue&type=script&lang=js&"
import style0 from "./QueueCompareModal.vue?vue&type=style&index=0&id=947b7f26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947b7f26",
  null
  
)

export default component.exports